import { render, staticRenderFns } from "./FoodyDeliveryAbout.vue?vue&type=template&id=39d18c08&"
import script from "./FoodyDeliveryAbout.vue?vue&type=script&lang=js&"
export * from "./FoodyDeliveryAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports